const base = {
  id: 'funke',
  projectName: 'innerdeutsche-grenze',
  baseUrl: 'https://interaktiv.waz.de',
  homepageUrl: 'https://www.waz.de',
  imprintUrl: 'https://www.waz.de/impressum/',
  privacyUrl: 'https://www.waz.de/datenschutz/',
  isStatic: false,
  staticDate: '14.11.2018',
  meta: {
    title: 'Zeichnen Sie die innerdeutsche Grenze!',
    description: 'In Berlin stand die Mauer - und ganz Deutschland trennte ein unüberwindlicher Grenzstreifen. Wissen Sie noch, wo der Todesstreifen zwischen DDR und Bundesrepublik verlief.',
    robots: 'index, follow',
    // facebook meta tags
    ogTitle: 'Zeichnen Sie die innerdeutsche Grenze!',
    ogDescription: 'Ein knapp 1400 Kilometern langer Todesstreifen trennte jahrzehntelang Deutschland. Können Sie zeigen, wo die Grenze verlief?',
    ogType: 'article',
    ogImage: 'images/wo-deutschland-geteilt-war-grenze_fb.jpg',
    ogSiteName: 'Funke Interaktiv',
    // twitter meta tags
    twSite: '@funkeinteraktiv',
    twCard: 'summary_large_image',
    twTitle: 'Zeichnen Sie die innerdeutsche Grenze!',
    twDescription: 'Ein knapp 1400 Kilometern langer Todesstreifen trennte jahrzehntelang Deutschland in zwei Teile. Können Sie zeigen, wo die Grenze verlief?',
    twImgSrc: 'images/wo-deutschland-geteilt-war-grenze_tw.jpg'
  },
  social: {
    whatsapp: 'Ein knapp 1400 Kilometern langer Todesstreifen trennte jahrzehntelang Deutschland. Weißt Du, wo? Zeichne die innerdeutsche Grenze! {{url}}',
    facebook: 'Ein knapp 1400 Kilometern langer Todesstreifen trennte jahrzehntelang Deutschland. Weißt Du, wo? Zeichne die innerdeutsche Grenze!',
    twitter: 'Ein knapp 1400 Kilometern langer Todesstreifen trennte jahrzehntelang Deutschland. Weißt Du, wo? Zeichne die innerdeutsche Grenze! #einheit {{url}}'
  },
  tracking: {
    enabled: true,
    id: '9011',
    section: 'Interaktiv',
    name: 'innerdeutsche-grenze',
    publishingDate: '02.10.2018'
  },
  teaser: {
    enabled: true,
    title: 'Wissen Sie noch, wo die Berliner Mauer stand?',
    description: 'Auf 43 Kilometern verlief die Mauer mitten durch Berlin. Können Sie zeigen, wo das war? Zeichnen Sie den Verlauf auf eine Karte ein.',
    background: 'images/teaser_berlinermauer.jpg',
    url: 'berliner-mauer-zeichnen/'
  },
  advertisment: {
    enabled: false,
    pageName: 'special1_story',
    siteId: 3088
  },
  appearance: {
    logoPath: 'fnk',
    faviconPath: 'fnk'
  }
};

module.exports = base;
